var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"transferPage"}},[_c('div',{staticStyle:{"margin-top":"40px"}}),_c('a-spin',{attrs:{"tip":"Loading..."}},[_c('div',{staticClass:"spin-content"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }